<input type="number"
       [value]="value"
       [readonly]="readonly"
       [disabled]="disabled"
       [min]="min"
       [max]="max"
       (change)="onChange($event)"
       onwheel="this.blur()">
